import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { youtubeTutorialsConfig } from '../youtubeTutorialsConfig';
import { YouTubeStackModal } from './YouTubeModal';
import { DivButton } from '../../commons/components/DivButton';
import { YoutubeIcon } from '../../assets/icons';
import { useIsSmallerThanTablet } from '../../responsive/hooks/hooks';

export const YouTubeTutorialButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();
  const isSmallerThanTablet = useIsSmallerThanTablet();
  const tutorialConfig = youtubeTutorialsConfig[location.pathname];

  if (!tutorialConfig) {
    return null;
  }

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <>
      {isSmallerThanTablet && (
        <DivButton className="mx-0 px-0" icon={<YoutubeIcon />} onClick={handleOpenModal} />
      )}
      {!isSmallerThanTablet && (
        <DivButton text="Learn how it works" icon={<YoutubeIcon />} onClick={handleOpenModal} />
      )}
      {isModalOpen && (
        <YouTubeStackModal
          videoId={tutorialConfig.videoId}
          onClose={handleCloseModal}
          title={tutorialConfig.title}
        />
      )}
    </>
  );
};
